import { formatNumbers } from "../../../../utils/NumberFormat";
import styles from "./ActiveJobOverview.module.css";
import { Row, Col, Card, Spin } from "antd";

const ActiveJobOverview = ({ data }) => {
  const boxData = [
    {
      label: "Candidates applied",
      count: data?.profCountData?.total || 0,
      percent: data?.profCountData?.profPercentageChange + "%" || "+20%",
      duration: "last month",
      newSignups: data?.profCountData?.newProfSignupsCurrentMonth || 0,
      positive: !data?.profCountData?.profPercentageChange?.includes("-"),
      description: "new signups",
    },
    {
      label: "Candidates IndexScored",
      count: data?.entCountData?.total || 0,
      percent: data?.entCountData?.entPercentageChange + "%" || "+2%",
      duration: "last month",
      newSignups: data?.entCountData?.newEntSignupsCurrentMonth || 0,
      positive: !data?.entCountData?.entPercentageChange?.includes("-"),
      description: "new signups",
    },
    {
      label: "Live job listings",
      count: data?.jobCountData?.total || 0,
      percent: data?.jobCountData?.jobPercentageChange + "%" || "+43%",
      duration: "last month",
      newSignups: data?.jobCountData?.newJobSignupsCurrentMonth || 0,
      positive: !data?.jobCountData?.jobPercentageChange?.includes("-"),
      description: "new jobs listed",
    },
    {
      label: "Filled positions",
      count: data?.jobOffersCountData?.total || 0,
      percent: data?.jobOffersCountData?.jobPercentageChange + "%" || "0%",
      duration: "last month",
      newSignups: data?.jobOffersCountData?.newJobSignupsCurrentMonth || 0,
      positive: !data?.jobOffersCountData?.jobPercentageChange?.includes("-"),
      description: "new positions filled",
    },
  ];

  return (
    <Row gutter={[8, 8]} className={styles.column_wrap}>
      {boxData.map((item) => {
        return (
          <Col xs={24} lg={6} md={12} sm={12} xl={6} key={item.label}>
            <Card className={styles.content_wrap}>
              {data?.entCountData ? (
                <>
                  <div className={styles.label}>{item.label}</div>
                  <div className={styles.count}>
                    {formatNumbers(item.count)}
                  </div>
                  <div className={styles.details}>
                    <span
                      className={
                        item.positive
                          ? styles.positive_percent
                          : styles.negative_percent
                      }
                    >
                      {item.percent}
                    </span>{" "}
                    from {item.duration} ({formatNumbers(item.newSignups)}{" "}
                    {item.description})
                  </div>
                </>
              ) : (
                <div className={styles.loader_wrap}>
                  <Spin />
                </div>
              )}
            </Card>
          </Col>
        );
      })}
    </Row>
  );
};

export default ActiveJobOverview;
